// extracted by mini-css-extract-plugin
export default {"title":"myProfile_title__myBoc"};